import { styled } from "@mui/material"
import { icons } from "../../assets/icons"

const PhoneIcon = icons.phoneIcon

export const ContentContainer = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "12px 0",
}

export const TitleContainer = {
  overflow: "hidden",
  flex: 1,
}

export const InfoTextCurrency = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: "4px",
  gap: "12px",
}

export const MasterFieldTimeTitle = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
}

export const AmountTitle = {
  textWrap: "nowrap",
}

export const InfoTextOverflow = {
  overflowWrap: "anywhere",
}

export const PhoneIconStyled = styled(PhoneIcon)({})
